export default function registerGraphEventListener(graph) {
  // #region 快捷键与事件
  graph.bindKey(["meta+c", "ctrl+c"], () => {
    const cells = graph.getSelectedCells();
    if (cells.length) {
      graph.copy(cells);
    }
    return false;
  });
  graph.bindKey(["meta+x", "ctrl+x"], () => {
    const cells = graph.getSelectedCells();
    if (cells.length) {
      graph.cut(cells);
    }
    return false;
  });

  graph.bindKey(["meta+v", "ctrl+v"], () => {
    if (!graph.isClipboardEmpty()) {
      const cells = graph.paste({ offset: 32 });
      graph.cleanSelection();
      graph.select(cells);
    }
    return false;
  });

  // undo redo
  graph.bindKey(["meta+z", "ctrl+z"], () => {
    if (graph.canUndo()) {
      graph.undo();
    }
    return false;
  });

  graph.bindKey(["meta+shift+z", "ctrl+shift+z"], () => {
    if (graph.canRedo()) {
      graph.redo();
    }
    return false;
  });

  // select all
  graph.bindKey(["meta+a", "ctrl+a"], (e) => {
    const nodes = graph.getNodes();
    if (nodes) {
      graph.select(nodes);
    }
  });

  graph.bindKey(["pageup"], (e) => {
    const cells = graph.getSelectedCells();
    if (cells) {
      cells.forEach((cell) => {
        cell.toFront(); // Bring each selected cell to the front
      });
    }
  });

  graph.bindKey(["pagedown"], (e) => {
    const cells = graph.getSelectedCells();
    if (cells) {
      cells.forEach((cell) => {
        cell.toBack(); // Bring each selected cell to the front
      });
    }
  });

  graph.bindKey(["escape"], (e) => {
    const cells = graph.getSelectedCells();
    if (cells) {
      graph.unselect(cells);
    }
  });

  // delete
  graph.bindKey(["backspace", "delete"], () => {
    const cells = graph.getSelectedCells();
    if (cells.length) {
      graph.removeCells(cells);
    }
  });

  // zoom
  graph.bindKey(["ctrl+1", "meta+1"], () => {
    const zoom = graph.zoom();
    if (zoom < 1.5) {
      graph.zoom(0.1);
    }
  });

  graph.bindKey(["ctrl+2", "meta+2"], () => {
    const zoom = graph.zoom();
    if (zoom > 0.5) {
      graph.zoom(-0.1);
    }
  });

  // 控制连接桩显示/隐藏
  const showPorts = (ports, show) => {
    for (let i = 0, len = ports.length; i < len; i += 1) {
      ports[i].style.visibility = show ? "visible" : "hidden";
    }
  };
  graph.on("node:mouseenter", ({ node }) => {
    const container = document.getElementById("graph-container");
    const ports = container.querySelectorAll(".x6-port-body");
    node.addTools([
      {
        name: "button-remove",
        args: {
          x: 0,
          y: 0,
          offset: { x: -10, y: -10 },
        },
      },
    ]);
    showPorts(ports, true);
  });
  graph.on("node:mouseleave", ({ node }) => {
    const container = document.getElementById("graph-container");
    const ports = container.querySelectorAll(".x6-port-body");
    node.removeTools();
    showPorts(ports, false);
  });

  //Edge Event
  graph.on("edge:mouseenter", ({ edge }) => {
    edge.addTools([
      { name: "vertices" },
      { name: "segments" },
      { name: "button-remove", distance: 0 },
    ]);
  });
  graph.on("edge:mouseleave", ({ edge }) => {
    edge.removeTools();
  });

  graph.on("cell:change:*", () => {
    const cell = JSON.stringify(graph.toJSON() ?? null);
    localStorage.setItem("sld.clipboard.cells", cell);
  });

  graph.on("node:added", ({ node, e }) => {
    if (node.shape == "power-meter-detail") {
      node.setAttrs({
        table: { visibility: true },
        name: { text: "" },
      });
    }
  });
}
